import { Checkbox, Dialog, FormControlLabel, List, Slide } from "@mui/material";
import { AddPageAlt, Edit, Trash } from "iconoir-react";
import { inject, observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MainButton from "../../components/button/MainButton";
import AlertDialog from "../../components/common/AlertDialog";
import { EmptyText, RichText } from "../../components/common/CellText";
import ContentEditor from "../../components/common/ContentEditor";
import Message from "../../components/common/Message";
import FileItem from "../../components/FileItemComponent/FileItem";
import CheckLight from "../../components/image/CheckLight";
import CheckSuccessIcon from "../../components/image/CheckSuccessIcon";
import CloseIcon from "../../components/image/CloseIcon";
import { getExtensionFile } from "../../utils/common";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});
const MissionUpdate = ({
    open,
    handleClose,
    taskDetail,
    fileStore,
    taskStore,
    getDetailTask,
}) => {
    const { taskId } = useParams();
    const [updateData, setUpdateData] = useState({
        files: [],
        ty_le_hoan_thanh: "",
        noi_dung_ket_qua: "",
        kien_nghi: "",
    });
    const [contentEditor, setContentEditor] = useState({
        isOpen: false,
        type: "",
    });
    const [alertDialog, setAlertDialog] = useState({
        isOpen: false,
        file_id: "",
    });
    const [message, setMessage] = useState({ title: "", isOpen: false });
    useEffect(() => {
        if (!open) return;
        const {
            phan_tram_hoan_thanh,
            noi_dung_ket_qua_giao,
            files,
            kien_nghi,
        } = taskDetail?.ket_qua;
        setUpdateData({
            ...updateData,
            ty_le_hoan_thanh: +phan_tram_hoan_thanh,
            noi_dung_ket_qua: noi_dung_ket_qua_giao,
            files: files,
            kien_nghi: kien_nghi,
        });
    }, [open]);

    const handleCloseEditor = () => {
        setContentEditor({ isOpen: false, type: "" });
    };

    const handleChangeTyLeHoanThanh = (e) => {
        e.target.checked
            ? setUpdateData({ ...updateData, ty_le_hoan_thanh: 100 })
            : setUpdateData({ ...updateData, ty_le_hoan_thanh: 0 });
    };
    const handleEditContent = (value) => {
        setUpdateData({ ...updateData, [contentEditor.type]: value });
        handleCloseEditor();
    };

    const handleChangeData = (event) => {
        setUpdateData({
            ...updateData,
            files: [
                ...updateData.files,
                {
                    file: event.target.files[0],
                    file_id: event.target.files[0].lastModified,
                    file_title: event.target.files[0].name,
                },
            ],
        });
    };
    const handleUpdate = async () => {
        const uploadFileList = updateData?.files?.filter(
            (item) =>
                !taskDetail?.ket_qua?.files?.some(
                    (file) => file.file_id === item.file_id
                )
        );
        const fileList = taskDetail?.ket_qua?.files?.filter((item) =>
            updateData?.files?.some((file) => file.file_id === item.file_id)
        );
        const batchUploadArr = [];
        uploadFileList
            .map((item) => item.file)
            .forEach((file) => {
                const formData = new FormData();
                formData.append("file", file);
                batchUploadArr.push(fileStore.uploadFile(formData));
            });
        const response = await Promise.all(batchUploadArr);
        const submitData = {
            ...updateData,
            files: response
                .map((response) => response.data.file_id)
                .concat(fileList?.map((file) => file.file_id)),
        };

        try {
            await taskStore.updateTask(taskId, submitData);
            setMessage({
                title: `Cập nhật thành công`,
                isOpen: true,
                severity: "success",
            });
            handleClose();
            getDetailTask();
        } catch (err) {
            setMessage({ title: err.vi, isOpen: true, severity: "error" });
        }
    };
    return (
        <>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <div className="px-5 mt-[14px] ">
                    <div className="flex items-center gap-5">
                        <span onClick={handleClose}>
                            <CloseIcon />
                        </span>
                        <span className="large-text">Cập nhật kết quả</span>
                    </div>
                    <div className="mb-[70px] min-h-screen mt-5">
                        <div className="small-text">Trạng thái</div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    onChange={handleChangeTyLeHoanThanh}
                                    checked={
                                        updateData.ty_le_hoan_thanh === 100
                                    }
                                />
                            }
                            label={" Hoàn thành"}
                        />
                        <div className="mb-2 small-text mt-[14px]">
                            Tài liệu đính kèm:
                        </div>
                        <div className="normal-text">
                            {updateData.files?.length > 0 &&
                                updateData.files.map((file) => (
                                    <div className="flex items-start justify-between gap-3">
                                        <FileItem
                                            file={file}
                                            key={file.file_id}
                                            file_id={file.file_id}
                                            file_name={file.file_title}
                                            file_type={getExtensionFile(
                                                file.file_title
                                            )}
                                        />
                                        <Trash
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setAlertDialog({
                                                    isOpen: true,
                                                    file_id: file.file_id,
                                                });
                                            }}
                                            className="flex-shrink-0 mt-1"
                                            color="red"
                                            width={12}
                                            height={14}
                                        />
                                    </div>
                                ))}
                        </div>

                        <input
                            style={{ display: "none" }}
                            id="upload_file"
                            type="file"
                            onChange={handleChangeData}
                        />
                        <label htmlFor="upload_file" className="">
                            <div className="inline-flex py-[10px] px-4 text-[#0073C7] gap-2 bg-ItemBg rounded-lg">
                                {" "}
                                <AddPageAlt width={15} height={16} />{" "}
                                <span className="font-semibold text-[14px] leading-[15px]">
                                    Thêm mới tài liệu
                                </span>
                            </div>
                        </label>

                        <div className="mb-2 small-text mt-[14px] flex items-center gap-2">
                            Nội dung kết quả:{" "}
                            <Edit
                                onClick={() => {
                                    setContentEditor({
                                        isOpen: true,
                                        type: "noi_dung_ket_qua",
                                    });
                                }}
                                width={12}
                                height={12}
                                color="#0073C7"
                            />
                        </div>
                        <div className="normal-text">
                            {updateData.noi_dung_ket_qua ? (
                                <RichText text={updateData.noi_dung_ket_qua} />
                            ) : (
                                <EmptyText>Không có</EmptyText>
                            )}
                        </div>
                        <div className="mb-2 small-text mt-[14px] flex items-center gap-2">
                            Kiến nghị:{" "}
                            <Edit
                                onClick={() => {
                                    setContentEditor({
                                        isOpen: true,
                                        type: "kien_nghi",
                                    });
                                }}
                                width={12}
                                height={12}
                                color="#0073C7"
                            />
                        </div>
                        <div className="normal-text">
                            {updateData.kien_nghi ? (
                                <RichText text={updateData.kien_nghi} />
                            ) : (
                                <EmptyText>Không có</EmptyText>
                            )}
                        </div>
                    </div>
                </div>
                <footer className="sticky bottom-0 bg-white px-5 py-[18px] shadow-[0px_0px_8px_rgba(0,0,0,0.25)] flex gap-3 items-center">
                    <MainButton onClick={handleUpdate}>Cập nhật</MainButton>
                </footer>
                <ContentEditor
                    open={contentEditor.isOpen}
                    handleClose={handleCloseEditor}
                    content={updateData[contentEditor.type] || ""}
                    handleOK={handleEditContent}
                />
                <AlertDialog
                    open={alertDialog.isOpen}
                    handleClose={() =>
                        setAlertDialog({ isOpen: false, file_id: "" })
                    }
                    title="Bạn muốn xóa tài liệu này?"
                    handleDelete={() => {
                        setUpdateData({
                            ...updateData,
                            files: updateData.files.filter(
                                (item) => item.file_id !== alertDialog.file_id
                            ),
                        });
                        setAlertDialog(false);
                    }}
                />
            </Dialog>
            <Message
                message={message.title}
                openMessage={message.isOpen}
                severity={message.severity}
                closeMessage={() => {
                    setMessage({ title: "", isOpen: false });
                }}
            />
        </>
    );
};

export default inject("taskStore", "fileStore")(observer(MissionUpdate));
